import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import AddEditSite from "./AddEditSite";
import { confirmDialog } from "primereact/confirmdialog";
import SiteDetail from "./SiteDetail";
import { Dropdown } from "primereact/dropdown";
import classNames from "classnames";
import { Formik, useFormik } from "formik";
import * as Yup from "yup";
import appUrl from "../../../config/appUrl";
const ManageSite = () => {
  const [displayDialog, setDisplayDialog] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [expandedRows, setExpandedRows] = useState([]);
 const [selectedSiteId, setSelectedSiteId] = useState(null); // for dropdown filter
const [editSiteData, setEditSiteData] = useState(null); // for edit popup data
  const [siteId, setSiteId] = useState("");
  const [addEditSite, setAddEditSite] = useState(false);
  const [siteDetail, setSiteDetail] = useState(false);
  const [isDynamicFee, setIsDynamicFee] = useState(false);
  const [siteValue, setSitevalue] = useState(null);
  const [loading, setLoading] = useState(true);
  const onHide = () => {
    setDisplayDialog(false);
    setEditSiteData(null);
    setAddEditSite(false);
    setSiteDetail(false);
  };
  const handleDialog = () => {
    setDisplayDialog(true);
  };

const editSite = async (rowData) => {
  try {
    const response = await fetch(
      `${appUrl.BASE_URL}Site/getSiteDetail?site=${rowData?._id}`
    );
    const data = await response.json();

    if (data?.data?.length > 0) {
      // ✅ Pass full site details to popup
      setEditSiteData(data.data[0]);
      setDisplayDialog(true);
      setAddEditSite(true);
      setSiteId(rowData?._id);
    }
  } catch (error) {
    console.error("Error fetching site detail:", error);
  }
};

const showSiteDetail = async (rowData) => {
  try {
    const response = await fetch(
      `${appUrl.BASE_URL}Site/getSiteDetail?site=${rowData?._id}`
    );
    const data = await response.json();

    if (data?.data?.length > 0) {
      setEditSiteData(data.data[0]);
      setDisplayDialog(true);
      setAddEditSite(false);
      setSiteDetail(true);
      setSiteId(rowData?._id);
      setIsDynamicFee(rowData.isDynamicFee);
    }
  } catch (error) {
    console.error("Error fetching site detail:", error);
  }
};

  const validationSchema = Yup.object().shape({
    // name: Yup.mixed().required("This field is required."),
  });
  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {},
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };
  const getSiteList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
      const data = await response.json();
      setSelectedSiteId(userSite);
      setSiteList(data?.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getSiteList();
  }, []);

  const storedLoginRes = JSON.parse(localStorage.getItem("user"));
  const userTypeIs = storedLoginRes?.role;
  const userSite = storedLoginRes?.site?._id;

  useEffect(() => {
    formik.setFieldValue("site", userSite);
    setSitevalue(userSite);
  }, [userSite]);

  useEffect(() => {
    const foundSite = siteList?.find((item) => item?._id === userSite);
    setSitevalue(foundSite);
  }, [userSite, siteList]);

  const statusTemp = (rowData) => {
    return <>{rowData?.active === true ? "Active" : "InActive"}</>;
  };

  const actionTemp = (rowData) => {
    return (
      <div className="flex">
        <Button
          tooltip="Detail"
          icon="pi pi-eye"
          tooltipOptions={{ position: "top" }}
          onClick={() => showSiteDetail(rowData)}
          className="p-button-rounded p-button-text"
        />
         <Button
          tooltip="Edit"
          icon="pi pi-user-edit"
          tooltipOptions={{ position: "top" }}
          onClick={() => editSite(rowData)}
          className="p-button-rounded p-button-text"
        />
      </div>
    );
  };

  const confirm = (rowData) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-primary",
      rejectClassName: "p-button-danger",
      accept: () => onDeleteConfirmation(rowData),
      reject,
    });
  };

  const onDeleteConfirmation = async (rowData) => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}site?siteId=${rowData?._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (response.ok) {
        await getSiteList();
      } else {
        console.error(data?.msg); // Error message from the API
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reject = () => {};

 

 

  return (
    <>
      <Dialog
        draggable={false}
        visible={displayDialog}
        style={{ width: "55vw" }}
        onHide={() => onHide("displayDialog")}
      >
        {/* <SiteDetail
          onHide={onHide}
          getSiteList={getSiteList}
          siteDetail={siteDetail}
          siteId={siteId}
          isDynamicFee={isDynamicFee}
        /> */}
        <AddEditSite
  editData={editSiteData}
  addEditSite={addEditSite}
  onHide={onHide}
  getSiteList={getSiteList}
  
  siteDetail={siteDetail}
  siteId={siteId}
  isDynamicFee={isDynamicFee}
/> 
      </Dialog>

      <div>
      <div className="p-fluid grid align-items-center">
        <div className="col-12 md:col-8">
            <div className="flex align-items-center">
            <h5
                className="mt-0 text-2xl mb-0 font-semibold text-[#17171B]"
                style={{ color: "#17171B" }}
              >
                Site Management
              </h5>
            </div>
          </div>
          <div className="col-12 md:col-2 ">
            {/* <label style={{ fontWeight: "bold" }}> Site </label> */}
           <Dropdown
  id="site"
  name="site"
  value={selectedSiteId}
  onChange={(e) => {
    formik.setFieldValue("site", e.target.value);
    setSiteId(e.target.value);
    setSelectedSiteId(e.target.value);
  }}
  filter
  showClear
  filterBy="site"
  filterMatchMode="contains"
  className={classNames(
    { "p-invalid": isFormFieldValid("site") },
    "TextArea__Round border-round-3xl"
  )}
  options={siteList}
  optionLabel="site"
  optionValue="_id"
  placeholder="Select Site"
  disabled={!!userSite}
/>
            {getFormErrorMessage("boothId")}
          </div>
          {!userSite && (
          <div className="col-12 md:col-2 text-right">
            <Button
              label="Add New"
              className="Add__New-Button"
              aria-label="Add User"
              onClick={() => {
                handleDialog();
                setAddEditSite(false);
                 setSiteDetail(false); 
              }}
              icon="pi pi-plus"
              iconPos="left"
            />
          </div>
          )}
        </div>
      </div>

      <div className="card custom_card p-datatable-sm">
        <DataTable
          value={siteList?.filter((site) =>
    selectedSiteId ? site._id === selectedSiteId : true
  )}
          paginator
          rows={10}
     
          scrollable
          responsiveLayout="scroll"
          header=""
          emptyMessage="No data found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
          stripedRows
        >
          <Column
            header="ID"
            body={(rowData) => (
              <div title={rowData._id} style={{ cursor: "pointer" }}>
                {`${rowData._id.slice(0, 6)}...${rowData._id.slice(-6)}`}
              </div>
            )}
          />
          <Column field="site" header="Site Name" />
          <Column field="location" header="Site Location" />
          <Column field="priceConfiguraiton" header="Configuration" />
       
         
       
          <Column body={actionTemp} header="Action" />
        </DataTable>
      </div>
    </>
  );
};

export default ManageSite;
